<template>
  <m-a :href="itemLink" class="text-decoration-none base-menu-item">
    <m-menu-icon-manager :itemIcon="itemIcon"/>
    <span class="base-menu-item-text">{{ itemText }}</span>
  </m-a>
</template>

<script>
import mA from '../Tags/A'
import mIcon from '../Icons/Icon'
import mMenuIconManager from "./MenuIconManager.vue";
export default {
  name: "BaseMenuItem",
  components: {mA, mIcon,mMenuIconManager},
  props: {
    itemLink: {
      default: 'javascript:void(0)'
    },
    itemIcon: {
      default: ''
    },
    itemText: {
      default: ''
    }
  }
}
</script>

<style scoped>

</style>